import React from "react";
import { colors } from "../../constants/theme";
import type { Item } from "../../types";
import { Badge } from "../ui/Badge";
import { timeAgo } from "../../utils/timeAgo";
import { getImageUrl, getImageId } from "../../utils/image";

interface TableViewProps {
  data?: Item[] | null;
  selectedId?: string | null;
  onSelect?: (id: string) => void;
  isQueue?: boolean;
}

const th: React.CSSProperties = { textAlign: "left", color: "#555", fontWeight: 700, fontSize: 12, padding: "4px 6px", borderBottom: `1px solid ${colors.border}` };
const td: React.CSSProperties = { color: colors.text, fontSize: 13, padding: "4px 6px", borderBottom: `1px solid ${colors.border}` };

export const TableView: React.FC<TableViewProps> = ({ data, selectedId = null, onSelect = () => {}, isQueue = false }) => {
  const rows: Item[] = Array.isArray(data) ? data : [];
  const renderTitleCell = (it: Item) => {
    if (isQueue) return it.filename ?? "—"; // Queue uses filename
    const t = it.meta?.title?.trim();
    return t && t.length > 0 ? t : "Untitled"; // Database uses title or Untitled
  };
  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          <th style={th}>Image</th>
          <th style={th}>{isQueue ? "Name" : "Title"}</th>
          <th style={th}>Status</th>
          <th style={th}>Location</th>
          <th style={th}>DeviceId</th>
          <th style={th}>Received</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr><td colSpan={6} style={{ ...td, color: colors.muted, textAlign: "center", padding: "12px 6px" }}>No items</td></tr>
        ) : (
          rows.map((it) => {
            const imageId = getImageId(it);
            const imageUrl = imageId ? getImageUrl(imageId, 'thumbnail') : null;
            const displayUrl = imageUrl || it.url;
            
            return (
            <tr key={it.id} onClick={() => onSelect(it.id)} style={{ cursor: "pointer", background: it.id === selectedId ? "#eef4ff" : undefined }}>
              <td style={td}>{displayUrl ? <img src={displayUrl} alt="thumb" style={{ width: 48, height: 36, objectFit: "cover", borderRadius: 4 }} /> : <div style={{ width: 48, height: 36, borderRadius: 4, background: "#eee", border: `1px solid ${colors.border}` }} />}</td>
              <td style={td}>{renderTitleCell(it)}</td>
              <td style={td}><Badge status={it.status} /></td>
              <td style={td}>{it.location ?? "—"}</td>
              <td style={td}>{it.deviceId ?? "—"}</td>
              <td style={td}>{it.receivedAt ? timeAgo(it.receivedAt) : "—"}</td>
            </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

